import sideView from "./components/sideView.vue";
import module from "../../store/module";
import { Pager } from "@/app/shared/components";

export default {
  components: {
    Pager,
    sideView
  },
  data() {
    return {
      selected: [],    
      itemsPerPage: 20,
      isMounted: false, 
      // Data Sidebar
      isSidebarActive: false,
      sidebarData: {}
    };
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    },
    energySourceUnitConversions() {
      return this.$store.state.decarbonization.energySourceUnitConversions;
    },
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.energySourceUnitConversions.length;
    }
  },
  methods: {
    refreshList() {
      this.$store.dispatch("decarbonization/fetchAllEnergySourceUnitConversions").finally(() => {
        this.$refs.listCard.removeRefreshAnimation();
      });
    },
    onPageChanged(val) {
      this.itemsPerPage = val;
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    openDeleteConfirm(id) {
      this.$deleteConfirmation({
        text: this.$t('Decarbonization.EnergySourceUnitConversion.ConfirmDelete'),
        accept:  () => this.deleteData(id)
      });
    },
    deleteData(id) {
      this.$vs.loading();
      this.$store.dispatch("decarbonization/removeEnergySourceUnitConversions", id)
        .then(() => {
          this.$notifyDeleteSuccess(this.$t("Decarbonization.EnergySourceUnitConversion.EnergySourceUnitConversionDeleted"));
        }).finally(() => {
          this.$vs.loading.close();
        });
    },
    editData(model) {
      //model.energySource = this.$t("Decarbonization.EnergySourcesEnum." + model.energySource);
      this.sidebarData = model;
      this.toggleDataSidebar(true);
    },
    toggleDataSidebar(val = false) {
      this.isSidebarActive = val;
    },
    onUpdated() {
      this.$notifySaveSuccess();
      this.toggleDataSidebar(false);
    },

    onInserted() {
      this.$notifySuccess(this.$t('InsertSuccess'));
      this.toggleDataSidebar(false);
    }
  },
  created() {
    if (!module.isRegistered) {
      this.$store.registerModule("decarbonization", module);
      module.isRegistered = true;
    }
  },
  mounted() {
    if (!this.isMounted) {
      this.$refs.listCard.refreshcard();
    }
    this.isMounted = true;
  }
};